// Library glyphs: icons only this lane uses (docs/implement/lanes.md).
// Key = the icon's name, value = Lucide geometry, as in Icon.tsx.

export { libraryGlyphs };

import { ArrowUpNarrowWide, CircleX, ListFilter, SearchX } from "lucide-react";
import type { AreaGlyphs } from "../Icon";

const libraryGlyphs = {
    "sort-ascending": ArrowUpNarrowWide, // Search's Sort button, oldest or A first
    filter: ListFilter, // Search's Filter button
    "clear-field": CircleX, // the × that empties the Search field
    "no-match": SearchX, // Search found nothing for the field
} satisfies AreaGlyphs;
